export const ProgressBarTransitionHelper = {
  lastDate: new Date(),
  isTransitionDone: true,

  setTransitionState: (isDone) => {
    ProgressBarTransitionHelper.isTransitionDone = isDone
    ProgressBarTransitionHelper.lastDate = new Date()
  }
}
